// extracted by mini-css-extract-plugin
module.exports = {"decoratedText":"FullDealCalculationsMinimal_decoratedText__8QoNE","badge":"FullDealCalculationsMinimal_badge__c0q1n"};